export const availableLanguages = [
  {
    code: 'en',
    name: 'English',
  },
  {
    code: 'de',
    name: 'Deutsch',
  },
];

export const defaultLanguage = 'en';
export const defaultCultureLanguage = 'en-EN';
